import script from "./BusinessCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessCard.vue?vue&type=script&setup=true&lang=js"

import "./BusinessCard.vue?vue&type=style&index=0&id=c7322da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7322da0"]])

export default __exports__